import { useSelector } from "react-redux";
import { Phone } from "lucide-react";
import ArrowSorting from "../../../../components/common/ArrowSorting";
import { CHECKPOINT_REPORT__COLUMNS } from "../../config/table.config";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import { checkValue } from "../../../../functions/checkValue";

export const CheckpointResult = () => {
  const data = useSelector((state) => state.data.data);
  return (
    <div className="bg-white rounded-xl shadow-sm mt-2">
      <div
        className={`whitespace-nowrap h-[calc(100vh-19em)] max-lg:h-[calc(100vh-17em)] max-md:h-[calc(100vh-16em)] overflow-auto`}
      >
        <table className="w-full border border-b-0">
          {/* Header */}
          <thead className="bg-[#f4f6fc] text-blue-1 uppercase text-[14px] max-lg:text-[11px] sticky top-0 2xs:max-md:top-0 z-99">
            <tr>
              {CHECKPOINT_REPORT__COLUMNS.map((c) => (
                <th key={c.title} className="text-left px-4 py-3">
                  <span className="flex items-center">
                    {c.title}{" "}
                    {c.sortArrow && data.length > 1 && (
                      <ArrowSorting
                        sortBy={c.sortBy}
                        address={c.address}
                        arrowColor="#3a4faa"
                      />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {/* Body */}
          <tbody className="text-[14px] max-lg:text-xs">
            {data.length > 0 ? (
              data.map((c) => (
                <tr
                  key={c.jobCardId}
                  className="border-t hover:bg-gray-50 text-gray-800 [&_td]:p-3"
                >
                  <td>{c.cylinderNo}</td>
                  <td>
                    {formatResultValue(c.resultVal)}
                    {c.gasKg != null && ` ${c.gasKg} kg`}
                  </td>
                  <td className="capitalize">{checkValue(c.lastDispatchValue)}</td>
                  <td>
                    <span>{c.fieldTechnician.name}</span>
                    <br></br>
                    <span className="flex items-center gap-1">
                      <Phone size={10} /> {c.fieldTechnician.mobileNumber}
                    </span>
                  </td>
                  <td>
                    <span>{c.supervisor.name}</span>
                    <br></br>
                    <span className="flex items-center gap-1">
                      {" "}
                      <Phone size={10} />
                      {c.supervisor.mobileNumber}
                    </span>
                  </td>
                  <td>{formatDate(c.submittedAt)}</td>
                  <td>{checkValue(c.lastWorkingStation)}</td>
                  <td>{c.doneBy}</td>
                  <td>{formatDate(c.doneAt)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={CHECKPOINT_REPORT__COLUMNS.length}
                  className="text-center py-6 text-gray-500"
                >
                  No match the current filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const formatResultValue = (value) => {
  if (value === null || value === undefined) return "";

  const numericValue = Number(value);

  if (value !== "" && !isNaN(numericValue)) {
    return `${value} kg`;
  }

  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};